import React, { Children, FC, PropsWithChildren } from 'react';
import { Col, Row } from 'reactstrap';

import { PageSectionTitle } from './PageSectionTitle';

interface Props {
  titleIcon: string;
  titleIconColor?: string;
  title: React.ReactNode;
  widths?: Array<{ xs?: number; md?: number; lg?: number }>;
  rightWidget?: React.ReactNode;
  id: string;
}

export const PageSection: FC<PropsWithChildren<Props>> = ({
  titleIcon,
  titleIconColor,
  title,
  children,
  widths,
  rightWidget,
  id,
}) => {
  return (
    <>
      <Row className="pb-4 pt-5" id={id}>
        <Col>
          <PageSectionTitle
            icon={titleIcon}
            iconColor={titleIconColor}
            rightWidget={rightWidget}
          >
            {title}
          </PageSectionTitle>
        </Col>
      </Row>
      <Row>
        {Children.toArray(children).map((child, i) => {
          return (
            // @ts-expect-error
            <Col {...(widths ? widths[i] : {})} key={child.key}>
              {child}
            </Col>
          );
        })}
      </Row>
    </>
  );
};
